/** @format */

import { useState, useContext, useCallback } from "react";
import { Context } from "../stores/Provider";
import { PostMethod } from "../api/Api";
import { getSession } from "../sessionStorage/sessionStorageMethod";
import { useLocation, useNavigate } from "react-router-dom";
import { logoutAbnormalFunction } from "../function/logoutAbnormalFunction";
import { initApiModelType, userAuthRequestType, userAuthResponseType } from "../constance/typeModel";
import { initApiResponse } from "../constance/constance";
import useNavigateByAgent from "./useNavigateByAgentHooks";

export const useAuthHooks = (IsLoggedIn: boolean) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state, dispatch } = useContext(Context);
  const { navigateByAgent } = useNavigateByAgent();
  const userInfoData = getSession("user");
  const [isAuthState, setIsAuthState] = useState<boolean>(false);
  const [isDirectState, setIsDirectState] = useState<boolean>(false);

  const checkUserAuth = async () => {
    let response: initApiModelType<userAuthResponseType> = initApiResponse;
    const data = {
      user_id: userInfoData !== 0 ? userInfoData.user_id : null,
      entry_id: userInfoData.entry_id !== 0 ? userInfoData.entry_id : null,
    };
    response = await PostMethod<userAuthRequestType, userAuthResponseType>(data, "/user_auth");

    if (response.code === 200 && response.response_data) {
      setIsAuthState(true);
      let closeScheduleDate = calculateCloseScheduleDate(response.response_data.confirm_date);

      dispatch({
        type: "set-context-data",
        payload: {
          user_status: {
            status: response.response_data.status,
            before_status: response.response_data.before_status,
            close_schedule_date: closeScheduleDate,
            confirm_flag: response.response_data.confirm_flag,
            cancel_flag: response.response_data.cancel_flag,
            economic_condition_confirmed_flag: response.response_data.economic_condition_confirmed_flag,
          },
        },
      });
    } else if (response.code === 401) {
      setIsAuthState(false);
      // ログインした情報があればログアウト
      if (userInfoData !== null && userInfoData.code === 200) {
        logoutAbnormalFunction(response, dispatch, navigateByAgent, state.agentPath, state.zAccount);
        return;
      }
      dispatch({
        type: "set-context-data",
        payload: {
          auth: {
            err_message: response.message,
          },
        },
      });
      navigate(state.agentPath + "/login");
    } else {
      setIsAuthState(false);
      navigate(state.agentPath + "/system_error");
    }
  };

  const calculateCloseScheduleDate = (confirmDate: string | null) => {
    if (!confirmDate) return null;

    const [datePart] = confirmDate.split(" ");
    const [year, month, date] = datePart.split("-").map(Number);

    const confirmDay = new Date(year, month - 1, date);
    confirmDay.setDate(confirmDay.getDate() + 30);

    return `${confirmDay.getFullYear()}年${confirmDay.getMonth() + 1}月${confirmDay.getDate()}日`;
  };

  const checkDirectAccess = useCallback(() => {
    const expectedPath = location.state?.routeTo || "";
    const currentPath = location.pathname;

    if (expectedPath === currentPath) {
      setIsDirectState(true);
      return;
    }

    dispatch({
      type: "set-context-data",
      payload: {
        auth: {
          err_message: "不正なアクセスです。再度ログインをお願いします。",
        },
      },
    });

    navigate(state.agentPath + "/login");
  }, [location.state, location.pathname, dispatch, navigate, state.agentPath]);
  return {
    isAuthState,
    isDirectState,
    checkUserAuth,
    checkDirectAccess,
  };
};
